/* RESPONSIBLE TEAM: team-frontend-tech */

export function loadScript(url: string, type = 'module'): Promise<void> {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    script.src = url;
    script.type = type;
    script.onload = () => resolve();
    script.onerror = (error) => reject(error);
    document.head.appendChild(script);
  });
}

export function loadStylesheet(
  url: string,
  parent: HTMLElement | ShadowRoot = document.head,
): Promise<void> {
  return new Promise((resolve, reject) => {
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = () => resolve();
    link.onerror = (error) => reject(error);
    parent.appendChild(link);
  });
}
